// extracted by mini-css-extract-plugin
module.exports = {"container":"mapping_container__3MQQ6","searchWrapper":"mapping_searchWrapper__73OPC page_searchWrapper__1RdJg"};